const SvgTrashIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      opacity={0.5}
    >
      <path d="M17.5 5.483a85 85 0 0 0-8.35-.416q-2.475 0-4.95.25l-1.7.166M7.084 4.642l.183-1.092c.133-.792.233-1.383 1.641-1.383h2.184c1.408 0 1.516.625 1.641 1.391l.184 1.084M15.708 8.117l-.542 8.391c-.091 1.309-.166 2.325-2.491 2.325h-5.35c-2.325 0-2.4-1.016-2.492-2.325l-.542-8.391" />
    </g>
  </svg>
);
export default SvgTrashIcon;
